import React, { useEffect, useState } from 'react';
import styles from './MoneyRain.module.css';

const EMOJIS = ['💵', '💰', '💲', '🤑', '💵', '💰', '💲', '💵', '💰', '🤑'];
const PARTICLE_COUNT = 60;

interface Particle {
  id: number;
  emoji: string;
  left: number; // % from left
  delay: number; // animation delay in s
  duration: number; // fall duration in s
  size: number; // font size in px
  wobble: number; // horizontal wobble offset
}

function generateParticles(): Particle[] {
  return Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
    id: i,
    emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
    left: Math.random() * 100,
    delay: Math.random() * 2,
    duration: 2.5 + Math.random() * 2,
    size: 24 + Math.random() * 28,
    wobble: -20 + Math.random() * 40,
  }));
}

interface MoneyRainProps {
  /** Set to true to trigger the animation */
  active: boolean;
  /** Duration in ms before auto-hiding (default: 5500) */
  duration?: number;
}

const MoneyRain: React.FC<MoneyRainProps> = ({ active, duration = 5500 }) => {
  const [visible, setVisible] = useState(false);
  const [particles] = useState<Particle[]>(() => generateParticles());

  useEffect(() => {
    if (active) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), duration);
      return () => clearTimeout(timer);
    }
  }, [active, duration]);

  if (!visible) return null;

  return (
    <div className={styles.container} aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.id}
          className={styles.particle}
          style={
            {
              left: `${p.left}%`,
              animationDelay: `${p.delay}s`,
              animationDuration: `${p.duration}s`,
              fontSize: `${p.size}px`,
              '--wobble': `${p.wobble}px`,
            } as React.CSSProperties
          }
        >
          {p.emoji}
        </span>
      ))}
    </div>
  );
};

export default MoneyRain;
